<template>
  <div>
    <div class="inner">
      <toptitle></toptitle>
      <datatable></datatable>
    </div>
  </div>
</template>

<script>
import toptitle from "@/components/prepareLessons/toptitle.vue";
import datatable from "@/components/prepareLessons/datatable.vue";
export default {
  data() {
    return {};
  },
  components: { toptitle, datatable },
  mounted() {},
  methods: {},
};
</script>

<style lang='less' scoped>
</style>